import {EntityWithCreatedAtMetadata} from './entityWithCreatedAtMetadata';
import {Moment} from 'moment';
import {UserSummary} from '../../account/modules/user/api/entity/userSummary.model';

export abstract class EntityWithAuditMetadata extends EntityWithCreatedAtMetadata{
    updatedAt: Moment;
    updatedBy: UserSummary;
}
